import Vue from 'vue'
import App from './App.vue'
import {LoaderHelper, Router} from "./core/index"
import './registerServiceWorker'

Vue.config.productionTip = false;

// Register all our application's partial components
LoaderHelper.autoregisterComponents();

// Register our global libraries
LoaderHelper.registerGlobalLibraries();

// Create our Vue instance
const app = new Vue({
  router: Router,
  // Store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app');

if(typeof window !== "undefined") {
  window.Cryo = app;
}